import { createLucideIcon } from 'lucide-react';
export const ToastInfoIcon = createLucideIcon('foobar', [
  [
    'path',
    {
      d: 'M11.9651 16C11.9651 16 11.9653 16.9529 11.9653 18',
      key: 'npujzn',
    },
  ],
  [
    'path',
    {
      d: 'M12 5C12 5 12.0002 8.81145 12.0002 13',
      key: '1nu07y',
    },
  ],
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
      key: '1mglay',
    },
  ],
]);
